import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setEditedProfile } from "redux/Actions";
import { useMutationEditProfile } from "services/api/mutations/useMutationEditProfile";
import { IProfileUpdateParams } from "types/Profile";
import TelefoneTextField from "ui/TelefoneTextField";
import * as Yup from "yup";
import { ICardapioAppState } from "../../redux/RootReducer";

type Props = {
  open: boolean;
  handleClose: () => void;
  id: number;
};

function EditProfileDialog({ open, handleClose, id }: Props) {
  const loginInfo = useSelector((state: ICardapioAppState) => state?.loginInfo);
  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false);
  const [mensagem, setMensagem] = useState<string>("");
  const dispatch = useDispatch();

  const { mutate: editProfile } = useMutationEditProfile();
  const formik = useFormik({
    initialValues: {
      id: id,
      name: "",
      phone_number: "",
    } as IProfileUpdateParams,
    validationSchema: Yup.object().shape({
      phone_number: Yup.string().required("Nome é obrigatório."),
      name: Yup.string()
        .min(3, "Problema no nome")
        .required("Telefone é obrigatório."),
    }),
    enableReinitialize: true,
    onSubmit: async (values: any) => {
      await editProfile(values);
      setMensagem("Perfil Editado com Sucesso");
      setOpenSnackBar(true);
      loginInfo!.name = values.name;
      loginInfo!.phone_number = values.phone_number;
      dispatch(setEditedProfile(loginInfo));
      localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
      formik.setSubmitting(false);
      setTimeout(() => {
        handleClose();
      }, 1000);
    },
  });
  const handleCloseSnackBar = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };
  return (
    <Dialog onClose={handleClose} open={open}>
      <Snackbar
        open={openSnackBar}
        autoHideDuration={6000}
        onClose={handleCloseSnackBar}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity="success"
          sx={{ width: "100%" }}
        >
          {mensagem}
        </Alert>
      </Snackbar>
      <DialogTitle>Primeiro edite seu perfil.</DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Box display={"flex"}>
            <TextField
              sx={{ marginTop: "20px", paddingX: 1 }}
              id="name"
              placeholder="Digite seu nome"
              variant="standard"
              type="text"
              value={formik.values.name}
              onChange={formik.handleChange}
              required
            />
            <TelefoneTextField
              id="phone_number"
              type="text"
              required
              variant="standard"
              onChange={formik.handleChange}
              value={formik.values.phone_number}
              sx={{
                marginTop: "20px",
                paddingX: 1,
                MozAnimation: "none",
                WebkitAppearance: "none",
                appearance: "none",
              }}
            />
          </Box>
          {(formik.errors.phone_number || formik.errors.name) && (
            <Alert
              severity="warning"
              sx={{
                display: "flex",
                flexGrow: 1,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography fontSize="14px" fontWeight={700}>
                Erro na edição
              </Typography>
            </Alert>
          )}
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={!(formik.isValid && formik.dirty)}
            fullWidth
            sx={{ color: "white", marginTop: "15px" }}
          >
            Salvar Perfil
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default EditProfileDialog;
